import React from 'react';
import './Batches.css';
import {Helmet} from "react-helmet";
const ProductCard = ({ product }) => {
  return (
    <div className="product-card">
      <Helmet>
                <meta charSet="utf-8" />
                <title>Batches - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
      <img src={product.image} loading="lazy" alt={product.name} className="product-image" />
      <div className="product-details">
        <div className="batch-tags">
          <span className="tag hinglish">HINGLISH</span>
          <span className="tag full-syllabus">FULL SYLLABUS</span>
        </div>
        <h2 className="product-name">{product.name}</h2>
        <p className="product-start">📅Started on: {product.startDate}</p>
        <p className="product-schedule">⏰As per class schedule</p>
        {product.monthlyfee && <p className="product-fees">💳Monthly fee: ₹ {product.monthlyfee}</p>}
        {product.billedamount &&<p className="product-billed">💼Billed amount till exams: ₹ {product.billedamount}</p>}
        {product.fullamount &&<p className="full-billed">💼Full course fee: ₹ {product.fullamount}</p>}
        <a href={product.explorePath} className="explore-button">Explore</a>
      </div>
    </div>
  );
};

export default ProductCard;
